module.exports = __webpack_public_path__ + "img/pharmaceutical.d81f1919.jpg";